import React, { useState,useEffect } from 'react';
import { 
  Button, 
  DatePicker, 
  Spin, 
  Table, 
  Typography,
  ConfigProvider
} from 'antd';
import { FaSearch, FaFilePdf } from 'react-icons/fa';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Api from '../api/Api';
import formatarValor from '../formatarValor';
import dayjs from 'dayjs';

const { Title } = Typography;
const { RangePicker } = DatePicker;

const RelatorioProdutos = () => {
  const [loading, setLoading] = useState(false);
  const [produtos, setProdutos] = useState([]);
  const [dates, setDates] = useState([null, null]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(20); // mostrar 20 itens por página

  const primaryColor = 'rgb(249, 130, 68)';
  const secondaryColor = 'rgb(247, 72, 115)';
  const gradient = `linear-gradient(135deg, ${primaryColor}, ${secondaryColor})`;

    useEffect(() => {
     document.title = "Relatório";
   
  }, []);


  const fetchProdutos = async () => {
    if (!dates[0] || !dates[1]) {
      toast.error('Selecione a data de início e fim.');
      return;
    }

    try {
      setLoading(true);
      const data = await Api.ListProdutoVendido({
        dataInicio: dates[0].format('YYYY-MM-DD'),
        dataFim: dates[1].format('YYYY-MM-DD')
      });
      setProdutos(data.map((p, idx) => ({ ...p, key: idx })));
      setCurrentPage(1); // resetar paginação ao filtrar
    } catch (error) {
      toast.error('Erro ao buscar produtos: ' + error.message);
    } finally {
      setLoading(false);
    }
  };

 
  const columns = [
     {
    title: 'Produto',
    dataIndex: 'produto',
    key: 'produto',
      width: 300,
    sorter: (a, b) => a.produto.localeCompare(b.produto)
  },


   {
     title: 'Documento',
     dataIndex: 'numero',
     key: 'numero',
     width: 300, // aumentei para ser a maior coluna
     sorter: (a, b) => a.numero.localeCompare(b.numero)
   },
   {
     title: 'Data Emissão',
     dataIndex: 'dataemissao',
     key: 'dataemissao',
     width: 140, // maior que antes
     render: (value) => value ? dayjs(value).format('DD/MM/YYYY') : '',
     sorter: (a, b) => dayjs(a.dataemissao).unix() - dayjs(b.dataemissao).unix()
   },

    
   {
     title: 'Preço',
     dataIndex: 'preco',
     key: 'preco',
     render: (value) => formatarValor(Number(value)),
     align: 'right',
     sorter: (a, b) => a.preco - b.preco
   },
   {
     title: 'Quantidade',
     dataIndex: 'quantidade',
     key: 'quantidade',
     align: 'center',
     sorter: (a, b) => a.quantidade - b.quantidade
   },
   {
     title: 'Total',
     dataIndex: 'total',
     key: 'total',
     render: (value) => <strong>{formatarValor(Number(value))}</strong>,
     align: 'right',
     sorter: (a, b) => a.total - b.total
   }
 ];


  const calcularTotalGeral = () => {
    return produtos.reduce((sum, p) => sum + Number(p.total), 0);
  };

  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: primaryColor,
          borderRadius: 8,
        },
      }}
    >
      <div style={{ padding: 24, background: '#f8f9fa', minHeight: '100vh' }}>
        <ToastContainer position="top-right" />

        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 24, flexWrap: 'wrap', gap: 16, alignItems: 'center' }}>
          <Title level={2} style={{ margin: 0, background: gradient, WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', display: 'inline-block' }}>
            PRODUTOS VENDIDOS
          </Title>

          <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap', alignItems: 'center' }}>
            <RangePicker
              format="DD/MM/YYYY"
              value={dates}
              onChange={(vals) => setDates(vals)}
              style={{ borderRadius: 8 }}
            />

            <Button 
              type="primary" 
              icon={<FaSearch />}
              onClick={fetchProdutos}
              style={{ background: gradient, border: 'none', borderRadius: 8 }}
            >
              Filtrar
            </Button>

          <Button 
  type="primary" 
  icon={<FaFilePdf />}
  style={{ background: gradient, border: 'none', borderRadius: 8 }}
  onClick={() => {
    if (!dates[0] || !dates[1]) {
      toast.error('Selecione a data de início e fim.');
      return;
    }
    const url = `https://kfood.milvendas.ao/pdf_relatorio/${dates[0].format('YYYY-MM-DD')}/${dates[1].format('YYYY-MM-DD')}`;
    window.open(url, "_blank"); // abre em nova aba
  }}
>
  Gerar PDF
</Button>

          </div>
        </div>

        <Spin spinning={loading}>
          <Table
            columns={columns}
            dataSource={produtos}
            pagination={{
              current: currentPage,
              pageSize: pageSize,
              total: produtos.length,
              onChange: (page) => setCurrentPage(page),
              showSizeChanger: true,
              pageSizeOptions: ['20', '50', '100']
            }}
            locale={{ emptyText: 'Nenhum produto encontrado' }}
            style={{ borderRadius: 8, overflow: 'hidden', boxShadow: '0 2px 8px rgba(0,0,0,0.05)' }}
            summary={() => (
              <Table.Summary.Row>
                <Table.Summary.Cell index={0} colSpan={5} style={{ textAlign: 'right', fontWeight: 'bold' }}>
                  Total Geral:
                </Table.Summary.Cell>
                <Table.Summary.Cell index={5} style={{ fontWeight: 'bold' }}>
                  {formatarValor(calcularTotalGeral())}
                </Table.Summary.Cell>
              </Table.Summary.Row>
            )}
          />
        </Spin>
      </div>
    </ConfigProvider>
  );
};

export default RelatorioProdutos;
